var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import Group from './group';
import Loading2 from "../main/loading2";
var ProductSeller = function () {
    var item = useSelector(function (state) { return state.product.item; });
    var marketList = useSelector(function (state) { return state.product.marketList; });
    var marketListLoaded = useSelector(function (state) { return state.product.marketListLoaded; });
    /**
     * 미니샵의 경우 일반, 카드 두가지 타입
     */
    var slice = {
        open: (marketList === null || marketList === void 0 ? void 0 : marketList.filter(function (v) { return v.mall_type === 3; })) || [],
        social: (marketList === null || marketList === void 0 ? void 0 : marketList.filter(function (v) { return v.mall_type === 4; })) || [],
        minishop: __spreadArray([], ((marketList === null || marketList === void 0 ? void 0 : marketList.filter(function (v) { return v.mall_type === 2 || v.mall_type === 1; })) || []), true),
    };
    return (React.createElement(Style, null,
        marketListLoaded ?
            React.createElement(Left, null,
                React.createElement(Group, { title: "\uC624\uD508\uB9C8\uCF13", kind: 0, data: slice.open, item_id: item === null || item === void 0 ? void 0 : item.item_id })) : React.createElement(Loading2, null),
        marketListLoaded ?
            React.createElement(Right, null,
                React.createElement(Group, { title: "\uC18C\uC15C\u00B7\uBC31\uD654\uC810\u00B7\uC804\uBB38\uBAB0", kind: 2, data: slice.social, item_id: item === null || item === void 0 ? void 0 : item.item_id }),
                slice.minishop.length > 0 && (React.createElement(Group, { title: "\uD589\uBCF5\uC1FC\uD551 \uBBF8\uB2C8\uC0F5", kind: 3, data: slice.minishop, item_id: item === null || item === void 0 ? void 0 : item.item_id }))) : React.createElement(Loading2, null)));
};
var Style = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    margin: 30px 0 0;\n    display: flex;\n    align-items: flex-start;\n\n    &:before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 50%;\n        width: 1px;\n        height: 100%;\n        background: #cdcdcd;\n    }\n"], ["\n    position: relative;\n    margin: 30px 0 0;\n    display: flex;\n    align-items: flex-start;\n\n    &:before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 50%;\n        width: 1px;\n        height: 100%;\n        background: #cdcdcd;\n    }\n"])));
var Left = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 50%;\n\n    .group {\n        border-left: 1px solid #cdcdcd;\n        border-bottom: 1px solid #cdcdcd;\n    }\n"], ["\n    width: 50%;\n\n    .group {\n        border-left: 1px solid #cdcdcd;\n        border-bottom: 1px solid #cdcdcd;\n    }\n"])));
var Right = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 50%;\n    border-right: 1px solid #cdcdcd;\n    border-bottom: 1px solid #cdcdcd;\n"], ["\n    width: 50%;\n    border-right: 1px solid #cdcdcd;\n    border-bottom: 1px solid #cdcdcd;\n"])));
export default ProductSeller;
var templateObject_1, templateObject_2, templateObject_3;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/product_seller/index.tsx
// module id = 224
// module chunks = 0